import React, {useCallback} from 'react';
import {Popup, setOptions, Button, toast} from "@mobiscroll/react";
import '@mobiscroll/react/dist/css/mobiscroll.min.css';
import '../styles/sharedQr.css';
import QRCode from "react-qr-code";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faXmark} from "@fortawesome/pro-duotone-svg-icons";

setOptions({
    theme: 'ios',
    themeVariant: 'light',
});

function QR({setQr, dialog, Dialog, qr, width, locale}) {

    const DialogClose = useCallback(() => {
        setQr({});
        Dialog({view: 'close'});
    }, [Dialog]);

    return (
        <Popup className="cs-shared-qr-popup" width={375} display="center" closeOnOverlayClick={false} closeOnEsc={false} scrollLock={false} buttons={[]} isOpen={dialog.view === 'sharedQr'} onClose={DialogClose}>
            <div className="mbsc-grid cs-shared-qr-header-col">
                <div className="mbsc-row cs-shared-qr-header-row">
                    {width > 576 &&
                        <div className="mbsc-col cs-shared-qr-header-col" />
                    }
                    <div className={width > 576 ? "mbsc-col cs-shared-qr-header-col mbsc-align-center" : "mbsc-col cs-shared-qr-header-col"}>
                        <Button className="cs-shared-qr-title-button mbsc-bold mbsc-txt-muted" variant="flat" >
                            {qr.title}
                        </Button>
                    </div>
                    <div className="mbsc-col cs-shared-qr-header-col mbsc-align-right">
                        <Button className="cs-shared-qr-close-button mbsc-bold" onClick={() => DialogClose()} variant="flat" >
                            &nbsp;<FontAwesomeIcon className="cs-shared-qr-close-icon" icon={faXmark} />
                        </Button>
                    </div>
                </div>
            </div>
            <div className="mbsc-row mbsc-justify-content-center cs-shared-qr-qr">
                <QRCode
                    size={256}
                    value={qr.url}
                    viewBox={`0 0 256 256`}
                />
            </div>
            <div className="mbsc-row mbsc-justify-content-center cs-shared-qr-helper">
                <p>
                    <a
                        href={qr.url}
                        onClick={(e) => {
                            e.preventDefault();
                            navigator.clipboard.writeText(qr.url)
                                .then(() => {
                                    toast({message: locale.sharedQr.a, color: 'info', display: 'bottom', duration: 1000});
                                })
                                .catch((err) => {
                                    console.error('Failed to copy link:', err);
                                });
                        }}
                        className="cs-shared-qr-links"
                    >
                        {qr.url}
                    </a>
                </p>
            </div>
        </Popup>
    );
}

export default QR;
